import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExpoBrandLayer from "../components/ExpoBrandLayer";

const ExpoBrandPage = () => {
    return (
        <MasterLayout>
            <ExpoBrandLayer />
        </MasterLayout>
    );
};

export default ExpoBrandPage;
